<template>
    <div class="history-wrapper">
        <template v-if="userInfo.isAuth">
            <div class="full-width">
                <div class="radio-container" v-if="userInfo.isFleet">
                    <label for="user" class="radio-label">
                        <input type="radio" v-model="query_type" id="user" value="user" />
                        <span>My History</span>
                    </label>

                    <label for="account" class="radio-label">
                        <input type="radio" v-model="query_type" id="account" value="account" />
                        <span>Fleet History</span>
                    </label>
                </div>
                <ul id="service-history-list">
                    <li class="mt-2" v-if="!userInfo.isFleet">
                        <div class="upgrade-link">
                            <a class="button" :href="getUrl('/accounts/fleet-upgrade')" title="Upgrade your account to view all of your call history."><span>Upgrade your account</span> to view all of your call history.</a>
                        </div>
                    </li>
                    <li class="no-history" v-if="history.length == 0">
                        <div>You do not have any call history to display</div>
                    </li>
                    <li class="service-history-item" v-for="transaction in history">
                        <div class="transaction-details">
                            <p>
                                <fa-icon :icon="['fas', 'location-dot']" aria-hidden="true"></fa-icon>
                                <strong>{{ transaction.listing.name }}</strong>
                            </p>
                            <span v-for="message in  getDetails(transaction)" class="text-subdued">{{ message }}.&nbsp;</span>
                        </div>
                        <div class="location-details">
                            <div is="vue:HoursStatusDisplay" :listing="transaction.listing"></div>
                            {{ transaction.listing.location.line1 }}<br />
                            {{ transaction.listing.location.line2 }}
                        </div>
                        <div class="contact-details">
                            <div class="labels">
                                <div v-for="phn in transaction.listing.phoneNumbers">
                                    <span>{{ phn.label }}:</span>
                                </div>
                            </div>
                            <div class="numbers">
                                <div v-for="phn in transaction.listing.phoneNumbers">
                                    <span>{{ phn.display }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="actions">
                            <button class="details-btn" @click="viewDetails(transaction)">
                                <fa-icon :icon="['fas', 'search']" aria-hidden="true"></fa-icon>View Listing
                            </button>
                        </div>
                    </li>
                </ul>
                <div class="results-count" v-if="history.length > 0">
                    <span>{{ displayText }}</span>

                    <button v-if="showMore" @click="loadMore">
                        <span v-if="isLoading">Loading</span>
                        <span v-if="!isLoading">
                            Load More
                            <fa-icon :icon="['fas', 'angle-double-right']" aria-hidden="true"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <marketing-action more-info-url="/shop/fleets">
                <template #heading>
                    <h2>Call History</h2>
                    <p>Automatically track the vendors you call.</p>
                </template>
                <template #subheading>
                    <h3>This is a free feature available to logged-in accounts</h3>
                    <h4>Create a <strong>free account</strong> or <strong>login</strong> to access vendors you have called!</h4>
                </template>
            </marketing-action>
        </template>
    </div>
</template>

<script>import script from './ServiceHistory';
    export default script;</script>

<style lang="less" scoped>
    @import "./ServiceHistory.less";
</style>